import { useMutation } from '@tanstack/react-query'
import {
  fetchSetupIntentClientSecret
} from 'utility/queries/payment'

export const useSetupIntentClientSecret = () => {
  return useMutation({
    mutationKey: ['setupIntentClientSecret'],
    mutationFn: fetchSetupIntentClientSecret,
  })
}